import NewspaperIcon from "@mui/icons-material/Newspaper";
import React from "react";

const EmailTemplate = [
  [
    "EmailTemplate",
    "/admin/email-template",
    <NewspaperIcon sx={{ fontSize: "2rem", ml: "0.3rem" }}></NewspaperIcon>,
  ],
];

export default EmailTemplate;
